import type { ComponentType } from 'react';
import type { IntlShape } from 'react-intl';

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import type { RemixFeedbackMetadata } from '@atlassian/conversation-assistant-action-helpers/utils/confluence-actions';

import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { createLazyCallbackHook } from '@confluence/loadable/entry-points/lazy-callback.ts';
import type { PageMode } from '@confluence/page-utils/entry-points/enums.ts';

import type { FeedbackVariant } from './FeedbackVariant.ts';

export const useLazyShowFeedbackFlag: (
	flags: FlagsStateContainer,
	intl: IntlShape,
	showModal: <T extends DialogsContainerProps>(
		component: ComponentType<T>,
		originalProps: Omit<T, keyof DialogsContainerProps> & Partial<DialogsContainerProps>,
	) => void,
	createAnalyticsEvent?: CreateUIAnalyticsEvent | undefined,
) => (args_0: {
	feedbackVariant: FeedbackVariant;
	sourceEntryPoint?: string;
	contentType?: string;
	contentMode?: PageMode;
	cloudId?: string;
	currentConversationId?: string;
	traceId?: string;
	requestId?: string;
	remixMetadata?: RemixFeedbackMetadata;
}) => Promise<void> = createLazyCallbackHook(
	async () =>
		(await import(/* webpackChunkName: "loadable-showFeedbackFlag" */ './showFeedbackFlag.tsx'))
			.showCreateWithRovoModalCloseFeedbackFlagThunk,
);
